module.exports = __webpack_public_path__ + "img/appAsset-agents-avatar-1.568d2db2.png";